import React, { useEffect, useState } from 'react';
import clsx from 'classnames';
import './index.css';
import TweenOne from 'rc-tween-one';
import { useAppContext } from '../../context/AppContext';
import { useCheckData } from '../../hooks';
import { usePageTitle } from '../../hooks';
import { message } from 'antd';

const Check = () => {
  usePageTitle('报告查询');
  const {
    state: { queryResultStatus },
    dispatch,
  } = useAppContext();
  const [no, setNo] = useState('');
  const [entrust, setEntrust] = useState('');
  const [lastNo, setLastNo] = useState('');
  const [msg, setMsg] = useState('');
  const [resultData, setResultData] = useState({});

  const { data, refresh, error } = useCheckData({
    id: `SJ${no}-${lastNo}`,
    name: entrust,
  });

  // 监听数据变化，请求成功后显示结果
  useEffect(() => {
    if (data && !error) {
      if (data?.code === 404) {
        setMsg(data?.message);
      } else {
        setResultData(data);
      }
      dispatch({
        type: 'SET_QUERY_RESULT_STATUS',
        payload: true,
      });
    }
  }, [data, error, dispatch]);

  // 监听错误状态，弹出错误提示
  useEffect(() => {
    if (error) {
      message.warning(`查询失败：${error}`);
    }
  }, [error]);

  const handleSearch = async () => {
    // 三个项都未填写
    if (!no && !entrust && !lastNo) {
      message.warning('请输入报告编号和委托单位进行查询');
      return;
    }
    // 只有报告编号填写
    if (no && !lastNo && !entrust) {
      message.warning('请输入报告编号和委托单位进行查询');
      return;
    }
    //只填写了报告编号后缀号
    if (!no && !entrust && lastNo) {
      message.warning('请输入报告编号和委托单位进行查询');
      return;
    }
    // 只有报告编号+后缀号填写
    if (no && lastNo && !entrust) {
      message.warning('请输入委托单位进行查询');
      return;
    }
    // 只有委托单位填写
    if (!no && entrust && !lastNo) {
      message.warning('请输入报告编号进行查询');
      return;
    }
    // 填写了报告编号+委托单位,但缺少报告编号后缀
    if (no && entrust && !lastNo) {
      message.warning('请输入报告编号进行查询');
      return;
    }
    // 填写了报告编号+委托单位,但缺少报告编号后缀
    if (!no && entrust && lastNo) {
      message.warning('请输入报告编号进行查询');
      return;
    }
    // 都不为空时,发送请求
    if (no && entrust && lastNo) {
      if (no.length !== 8 || lastNo.length !== 2) {
        message.warning('请输入正确的报告编号,例如 SJ20230401-01');
        return;
      }
      try {
        await refresh();
        // 成功后的处理逻辑已移至 useEffect 中
      } catch (err) {}
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const result = [
    {
      title: '报告编号',
      valueKey: '报告编号',
    },
    {
      title: '委托单位',
      valueKey: '送检单位',
    },
    {
      title: '委托日期',
      valueKey: '委托日期',
    },
    {
      title: '签发日期',
      valueKey: '报告签发日期',
    },
    {
      title: '检测单位',
      valueKey: '检测单位',
    },
    {
      title: '防伪查询',
      valueKey: '防伪查询',
    },
  ];

  const onBack = () => {
    setMsg('');
    dispatch({
      type: 'SET_QUERY_RESULT_STATUS',
      payload: false,
    });
  };

  return (
    <div className={clsx('check')}>
      <div className={clsx('check-content')}>
        <div className={clsx('check-mask')} />
        {/* 查询框 */}
        {!queryResultStatus ? (
          <TweenOne
            className={clsx('check-content-search')}
            animation={{ y: 40, opacity: 0, type: 'from' }}
          >
            <div className={clsx('check-content-search-title')}>
              检测报告查询
              <div className={clsx('check-content-search-tips')}>
                示例：SJ20230401-01
              </div>
            </div>
            <div className={clsx('check-content-search-input-wrapper-special')}>
              <div
                className={clsx(
                  'check-content-search-input-wrapper-special-label',
                )}
              >
                SJ
              </div>
              <input
                type='text'
                className={clsx('check-content-search-special-input')}
                placeholder='请输入报告编号'
                value={no}
                inputMode='numeric'
                onChange={(e) =>
                  setNo(e.target.value.replace(/\D/g, '').slice(e, 8))
                }
                onKeyPress={handleKeyPress}
              />
              <div
                className={clsx(
                  'check-content-search-input-wrapper-special-line',
                )}
              >
                -
              </div>
              <input
                type='text'
                className={clsx('check-content-search-input-last')}
                value={lastNo}
                maxLength={2}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
                onChange={(e) => setLastNo(e.target.value?.trim())}
              />
            </div>
            <div className={clsx('check-content-search-input-wrapper')}>
              <input
                type='text'
                className={clsx('check-content-search-input')}
                placeholder='请输入委托单位'
                value={entrust}
                onChange={(e) => setEntrust(e.target.value?.trim())}
                onKeyPress={handleKeyPress}
              />
            </div>
            <div className={clsx('check-content-search-input-wrapper')}>
              <button
                className={clsx('check-content-search-button')}
                onClick={handleSearch}
              >
                查询
              </button>
            </div>
          </TweenOne>
        ) : null}
        {/* 查询结果 */}
        {queryResultStatus ? (
          <TweenOne
            className={clsx('check-result')}
            animation={{ y: -40, opacity: 0, type: 'from' }}
          >
            <div className={clsx('check-result-title')}>查询结果</div>
            {msg ? (
              <div className={clsx('check-result-msg')}>{msg}</div>
            ) : (
              <>
                {result.map((item, index) => {
                  return (
                    <div className={clsx('check-result-item')} key={index}>
                      <div className={clsx('check-result-item-title')}>
                        {item.title}
                      </div>
                      <div className={clsx('check-result-item-value')}>
                        {resultData[item.valueKey]}
                      </div>
                    </div>
                  );
                })}
              </>
            )}
            <button className={clsx('check-result-back')} onClick={onBack}>
              返回
            </button>
          </TweenOne>
        ) : null}
      </div>
    </div>
  );
};

export default Check;
